import ReportsLibPage from "./ReportsLibPage.vue";

export default [
    {
        path: "/reports/:reportName",
        component: ReportsLibPage,
        name: "reports",
    },
];
